import { render, staticRenderFns } from "./OurPhilosophySwiper.vue?vue&type=template&id=13daeb26&scoped=true&"
import script from "./OurPhilosophySwiper.vue?vue&type=script&lang=js&"
export * from "./OurPhilosophySwiper.vue?vue&type=script&lang=js&"
import style0 from "./OurPhilosophySwiper.vue?vue&type=style&index=0&id=13daeb26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13daeb26",
  null
  
)

export default component.exports